<template>
  <div>
    <date-filter
      :filters="filters"
      :setups-count="filteredSetups.length"
      :carrozzeria="carrozzeria"
      @filter-changed="applyFilter"
    ></date-filter>

    <car-equipment :quotation_id="quotation_id" :setups="filteredSetups"></car-equipment>
  </div>
</template>

<script>
import DateFilter from './DateFilter.vue';
import CarEquipment from './CarEquipment.vue';

export default {
  name: 'CarFilterContainer',
  components: {
    DateFilter,
    CarEquipment,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filters: this.data.general_info.filters,
      setups: this.data.setups,
      filteredSetups: this.data.setups,
      carrozzeria: this.data.general_info.carrozzeria,
      quotation_id: this.data.general_info.quotation_id,
    };
  },
  methods: {
    applyFilter(filter) {
      if (filter === null) {
        this.filteredSetups = this.setups;
      } else {
        const [start, end] = filter.split(' al ');
        this.filteredSetups = this.setups.filter(setup => {
          return setup.inizioVendita === start && setup.fineVendita === end;
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/CarFilterContainer.vue